import styled from 'styled-components';

const RemunerationWrapper = styled.div`
  padding: 3rem;
`;

export default RemunerationWrapper;
